module.exports = __webpack_public_path__ + "img/BlueArrowDownIcon.35fb73e2.svg";